import React from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'
import MediaQuery from 'react-responsive'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import ObjectiveImage from '../../images/simulator.png'
import { InvestmentSelect } from '../investmentSelect'
import { RentabilityDialog } from '../rentabilityDialog'
import * as S from './styles'

const ObjectiveSchema = Yup.object().shape({
	age: Yup.number()
	.min(1, 'A idade deve estar entre 1 e 100.')
	.max(100, 'A idade deve estar entre 1 e 100.')
	.required('Preencha este campo.'),
	independenceAge: Yup.number()
	.min(Yup.ref('age'), 'A idade para independência financeira deve ser maior que sua idade.')
	.max(100, 'A idade deve ser menor que 100.')
	.required('Preencha este campo.'),
	investment: Yup.string()
})

export function Objective({ data, setData, setStepState, stepState }) {
	const [open, setOpen] = React.useState(false)

	const handleClickOpenDialog = () => {
		setOpen(true)
	}

	const handleCloseDialog = () => {
		setOpen(false)
	}

	return (<Formik
	styles={{
		container: {
			justifyContent: 'center', 
		}
	}}
	validateOnBlur={false}
	validateOnChange={false}
	initialValues={data}
	validationSchema={ObjectiveSchema}
	onSubmit={(values) => {
		setData({ ...values, investment: data.investment })
		const enable = stepState.enable > 1 ? stepState.enable : 1
		setStepState({
			index: 1,
			enable
		})
	}}
	>
		{({ values, errors, handleChange, handleSubmit, dirty }) => (<>
			<S.Container style={{
				justifyContent: 'center',
			}}>
				<S.Form>
					<TextField
					fullWidth
					variant="filled"
					id="age" name="age" type="number"
					onChange={handleChange}
					label="Qual sua idade?" value={values.age}
					error={!!errors.age} helperText={errors.age || ' '}/>
					<TextField
					fullWidth variant="filled"
					id="independenceAge" name="independenceAge" type="number"
					onChange={handleChange}
					value={values.independenceAge} label="Com que idade deseja independência financeira?"
					error={!!errors.independenceAge} helperText={errors.independenceAge || ' '}/>
					<InvestmentSelect setData={setData} handleChange={handleChange} data={data} openDialog={handleClickOpenDialog}/>
				</S.Form>
				{/* <MediaQuery query="(min-width: 1024px)">
					<S.BoxImage>
						<S.Image src={ObjectiveImage} alt="Qual o seu objetivo?" title="Qual o seu objetivo?"/>
					</S.BoxImage>
				</MediaQuery> */}
			</S.Container>
			<RentabilityDialog open={open} handleCloseDialog={handleCloseDialog} data={data} />
			<S.Footer style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
			}}>
				<S.Hr style={{
					width: '100%',
				}}/>
				<Button onClick={() => {
					handleSubmit()
				}} disabled={!values.independenceAge || !values.age} variant="contained" color="primary">PRÓXIMO PASSO</Button>
			</S.Footer>
		</>)}
	</Formik>)
}
